'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RSS;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function RSS(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-rss ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z' })
  );
}

RSS.propTypes = _.IconPropTypes;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/RSS/RSS.js
// module id = 141
// module chunks = 0 1 2 3 4 5 6 7 8 9